import {
    ExternalImagesOptions,
    getOptionsForFeature,
    OwsOptionsFeatureType,
} from 'owa-outlook-service-options';
import getSelectedOptionKey from '../selectors/getSelectedOptionKey';

/**
 * Returns if External Images option state is dirty or not.
 */
export default function isExternalImagesOptionDirty() {
    const userOptions = getOptionsForFeature<ExternalImagesOptions>(
        OwsOptionsFeatureType.ExternalImages
    );
    return getSelectedOptionKey() != userOptions.externalImagesSelectedOption;
}
